import { useApi } from 'api/api-context';
import useOrganizationModules from 'features/organization-modules/use-organization-modules';
import { Navigate, Outlet } from 'react-router-dom';
import { DASHBOARD_PAGE_PATH } from 'routes/paths';

interface Props {
  module: 'priceOffers' | 'hr' | 'revisions' | 'forms' | 'revisionTemplates' | ('revisions' | 'forms')[];
  permissionByModule?: Partial<Record<'revisions' | 'forms', string>>;
}

/**
 * Prevents direct navigation into modules disabled for the user's direct organization.
 */
export default function RequireOrganizationModule({ module, permissionByModule }: Props) {
  const modules = useOrganizationModules();
  const { hasPermissionAnywhere } = useApi();
  const requiredModules = Array.isArray(module) ? module : [module];

  const hasEnabledModule = requiredModules.some(
    (requiredModule) =>
      modules[requiredModule] &&
      (!permissionByModule?.[requiredModule as 'revisions' | 'forms'] ||
        hasPermissionAnywhere(permissionByModule[requiredModule as 'revisions' | 'forms']!))
  );

  if (!hasEnabledModule) {
    return <Navigate to={DASHBOARD_PAGE_PATH.original} replace />;
  }

  return <Outlet />;
}
